import * as actions from './ContextualSidebarActions';

const initialState = {
  isCollapsed: false,
};

export default (state = initialState, { type, ...action }) => {
  switch (type) {
    case actions.SET_IS_COLLAPSED:
      return { ...state, isCollapsed: action.isCollapsed };
    default:
      return state;
  }
};
